




























































import Vue from 'vue'
import FullModalLayout from '@/components/modal/basics/FullModal/FullModalLayout.vue'
import FullModalHeaderCloseButton from '@/components/modal/basics/FullModal/FullModalHeader/FullModalHeaderCloseButton.vue'
import FullModalHeaderTitle from '@/components/modal/basics/FullModal/FullModalHeader/FullModalHeaderTitle.vue'
import Dropdown from '@/components/globals/basics/Dropdown.vue'
import SelectButton from '@/components/modal/basics/SelectButton.vue'
import dayjs from 'dayjs'

export interface Time {
  hour: string
  minute: string
}

export interface TimeRange {
  from: Time
  to: Time
}

export default Vue.extend({
  components: {
    FullModalLayout,
    FullModalHeaderCloseButton,
    FullModalHeaderTitle,
    Dropdown,
    SelectButton,
  },
  props: {
    name: {
      type: String as () => string,
      default: 'ProgramTimeModal',
    },
    value: {
      type: Object as () => TimeRange,
      required: true,
    },
    // Hour/Minuteがすべて入力必須になる
    required: {
      type: Boolean,
      default: false,
    },
  } as const,
  data() {
    return {
      from: {
        hour: '',
        minute: '',
      } as Time,
      to: {
        hour: '',
        minute: '',
      } as Time,
    }
  },
  computed: {
    isInvalid(): boolean {
      return !this.required
        ? (this.from.hour !== '' && !this.from.minute) ||
            (this.to.hour !== '' && !this.to.minute)
        : this.from.hour === '' ||
            this.from.minute === '' ||
            this.to.hour === '' ||
            this.to.minute === ''
    },
    hours(): string[] {
      return Array.from(Array(24).keys()).map((i) => String(i).padStart(2, '0'))
    },
    hoursOption(): object[] {
      return [
        ...[{ text: '', value: '' }],
        ...this.hours.map((hour) => ({ text: hour, value: hour })),
      ]
    },
    hoursOptionAfter(): object[] {
      return this.hours
        .filter((hour) => Number(this.from.hour) <= Number(hour))
        .map((hour) => ({ text: hour, value: hour }))
    },
    minutes(): string[] {
      return ['', '00', '15', '30', '45']
    },
    minutesOption(): object[] {
      return this.minutes.map((minute) => {
        return { text: minute, value: minute }
      })
    },
    minutesOptionAfter(): object[] {
      return Number(this.from.hour) < Number(this.to.hour)
        ? this.minutesOption
        : this.minutes
            .filter((minute) => Number(this.from.minute) <= Number(minute))
            .map((minute) => {
              return { text: minute, value: minute }
            })
    },
  },
  watch: {
    'from.hour': function (fromHour: string) {
      // 00分を自動セット
      if (fromHour !== '' && this.from.minute === '') {
        this.from.minute = '00'
      }
      // 〜xxの時間が、xx〜の時間より前になってしまっていたら一旦削除
      if (Number(fromHour) > Number(this.to.hour)) {
        this.to = { hour: '', minute: '' }
      }
    },
    'to.hour': function (toHour: string) {
      if (toHour !== '' && this.to.minute === '') {
        this.to.minute = '00'
      }
    },
  },
  methods: {
    onSubmit(): void {
      this.$emit('onSubmit', { from: { ...this.from }, to: { ...this.to } })
      this.$modal.pop()
    },
    isValidBeforeAndAfter(before: string, after: string): boolean {
      if (after === '') return true
      try {
        return (
          dayjs(before).isSame(dayjs(after)) ||
          dayjs(before).isBefore(dayjs(after))
        )
      } catch (e) {
        return false
      }
    },
    beforeOpen(): void {
      this.from = { ...this.value.from }
      this.to = { ...this.value.to }
    },
    beforeClose(): void {
      // 閉じる前に内部の値は全て初期化しておく
      this.from = { hour: '', minute: '' }
      this.to = { hour: '', minute: '' }
    },
  },
})
